import { render, staticRenderFns } from "./TablePendingRegistration.vue?vue&type=template&id=fd8d8e64&scoped=true"
import script from "./TablePendingRegistration.vue?vue&type=script&lang=js"
export * from "./TablePendingRegistration.vue?vue&type=script&lang=js"
import style0 from "./TablePendingRegistration.vue?vue&type=style&index=0&id=fd8d8e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8d8e64",
  null
  
)

export default component.exports